<template>
  <div >
    <div class="filter-inline-panel cle">
      <el-form :inline="true" :model="filterForm" class="filter-panel">
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="bianjDelete('')" v-if="user_type==2">新建</el-button>
      </div>
    </div>
    <div>
      <el-table :data="list" size="mini" border>
        <el-table-column prop="user_name" align="center" label="用户名称"></el-table-column>
        <el-table-column label="操作" align="center" v-if="user_type==2">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="mima(scope.row)">重置密码</el-button>
            <el-button size="mini" type="info" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <p><br></p>
    </div>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="编辑" custom-class="add-data-base" :visible="addxuangDialog" @close="addxuangDialog = false" width="900px">
      <el-form label-width="100px" ref="yungong" :rules="yungongRules" :model="yungong">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户类型：" prop="user_type">
              <el-select v-model="yungong.user_type" placeholder="请选择用户类型" class="w100">
                <el-option label="普通用户" value="1"></el-option>
                <el-option label="管理员" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="user_name">
              <el-input v-model="yungong.user_name" placeholder="请输入用户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码：" prop="password">
              <el-input v-model="yungong.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确定密码：" prop="re_password">
              <el-input v-model="yungong.re_password" show-password placeholder="请确定密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addxuangDialog=false">取 消</el-button>
        <el-button type="primary" @click="yungongaddNew('yungong')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="重置密码" custom-class="add-data-base" :visible="mima_is" @close="mima_is = false" width="900px">
      <el-form label-width="100px" ref="mima_data" :rules="mimaRules" :model="mima_data">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item label="密码：" prop="password">
              <el-input v-model="mima_data.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确定密码：" prop="re_password">
              <el-input v-model="mima_data.re_password" show-password placeholder="请确定密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mima_is=false">取 消</el-button>
        <el-button type="primary" @click="mima_f('mima_data')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.yungong.re_password !== '') {
					this.$refs.yungong.validateField('re_password');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.yungong.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		var validatePass3 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.mima_data.re_password !== '') {
					this.$refs.mima_data.validateField('re_password');
				}
				callback();
			}
		};
		var validatePass4 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.mima_data.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			mima_data: {
				password: '',
				re_password: '',
			},
			list: [],
			yungong: {
				user_type: '',
				user_name: '',
				password: '',
				re_password: '',
			},
			yungongRules: {
				user_type: [{
					required: true,
					message: '请选择用户类型',
					trigger: 'change'
				}, ],
				user_name: [{
					required: true,
					message: '请输入菜单名称',
					trigger: 'blur'
				}, ],
				password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur',
					},
					{
						validator: validatePass,
						trigger: 'blur'
					}
				],
				re_password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},
					{
						validator: validatePass2,
						trigger: 'blur',
						required: true
					}
				],
			},
			mimaRules: {
				password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur',
					},
					{
						validator: validatePass3,
						trigger: 'blur'
					}
				],
				re_password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},
					{
						validator: validatePass4,
						trigger: 'blur',
						required: true
					}
				],
			},
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			addxuangDialog: false,
			mima_is: false,
			filterForm: {
				realName: '',
			},
			id: '',
			user_type:'',
		}
	},
	// 初始事件
	mounted: function () {
		this.user_type = sessionStorage.getItem('user_type') || '';
		this.init();
	},
	// 事件
	methods: {
		init: function () {
			var this_ = this;
			var url = "userList"
			var datas = {
				page: this_.pages.page,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		bianjDelete(e) {
			if (e) {
				this.yungong = e;
			} else {
				this.yungong = {
					user_type: '',
					user_name: '',
					password: '',
					re_password: '',
				}
			}
			this.addxuangDialog = true;
		},
		yungongaddNew: function (formName) {
			var url = "addUser";
			var this_ = this;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var datas = {
						user_type: this.yungong.user_type,
						user_name: this.yungong.user_name,
						password: this.yungong.password,
						re_password: this.yungong.re_password,
					}
					var tishi = '用户创建成功';
					this.$post(url, datas).then((res) => {
						this.$message.success(tishi);
						this.addxuangDialog = false;
						this.init();
					});
				} else {
					return false;
				}
			});
		},
		mima_f: function (yungongs) {
			var url = "changePassword";
			var this_ = this;
			this.$refs[yungongs].validate((valid) => {
				if (valid) {
					var datas = {
						password: this.mima_data.password,
						re_password: this.mima_data.re_password,
						user_id: this.id,
					}
					var tishi = '重置密码成功';
					this.$post(url, datas).then((res) => {
						this.$message.success(tishi);
						this.mima_is = false;
						this.$refs[yungongs].resetFields();
						this.init();
					});
				} else {
					return false;
				}
			});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},

		deleteUser(index, data) {
			var this_ = this;
			var url = "deleteUser";
			var datas = {
				id: data.id
			}
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},
		mima(data) {
			this.id = data.id;
			this.mima_is = true;
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 18px;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
.content-panel {
	min-height: calc(100vh - 252px);
	/* background: #ffffff; */
	padding: 25px 30px;
}
.content-panel .page-pagination {
	padding: 25px 10px;
	text-align: right;
}
.content-panel .page-pagination .filter-inline-panel {
	margin-bottom: 25px;
}
.content-panel .page-pagination .filter-inline-panel .add-data-base .el-select {
	width: 100%;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.dialog-bottom-btn {
	text-align: center;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/staff.vue